import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import ClearReset from "../components/ClearReset";
import {
  CBSDisplayFields,
  CBFDisplayFields,
  SISDisplayFields,
  SIFDisplayFields,
   selectedInsuranceFunds,
  selectedCharterTypes,
  selectedTransactionTypes,
} from "../refdata/FilterOptions";

function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    clearResetState: (report?: string, aggReport?: boolean) => {
      const displayFields: {[key: string]: string[]} = {
        CBS: CBSDisplayFields,
        CBF: CBFDisplayFields,
        SIS: SISDisplayFields,
        SIF: SIFDisplayFields,
      };
      if (report) {
        if (aggReport) {
          dispatch(actions.updateUi("aggReport", report));
          dispatch(actions.updateFilter("selectedInsuranceFunds",selectedInsuranceFunds.map(funds => funds.value)));
          dispatch(actions.updateFilter("selectedCharterTypes", selectedCharterTypes.map(charter => charter.value)));
          dispatch(actions.updateFilter("selectedTransactionTypes",selectedTransactionTypes.map(transaction => transaction.value)));
        } else {
          dispatch(actions.updateFilter("selectedReport", report));
          dispatch(actions.updateDisplayFields(displayFields[report]));
        }
      } else {
        if (aggReport) {
          dispatch(actions.updateFilter("selectedInsuranceFunds", [""]));
          dispatch(actions.updateFilter("selectedCharterTypes", [""]));
          dispatch(actions.updateFilter("selectedTransactionTypes",[""]));
        } else {
          dispatch(actions.updateDisplayFields([""]));
        }
      }
      dispatch(actions.searchPush());
    },
  };
}
export default connect(null, mapDispatchToProps)(ClearReset);
